import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styles from './AnimatedStepSwitcher.module.scss';

const AnimatedStepSwitcher = ({ children, stepKey, direction: propDirection }) => {
  const prevStepRef = useRef(stepKey);
  const directionRef = useRef('forward');

  if (stepKey !== prevStepRef.current) {
    if (stepKey < prevStepRef.current) {
      directionRef.current = 'backward';
    } else {
      directionRef.current = 'forward';
    }
    prevStepRef.current = stepKey;
  }

  const activeDirection = propDirection || directionRef.current;

  const animClasses = {
    forward: {
      enter: styles.forwardEnter,
      enterActive: styles.forwardEnterActive,
      exit: styles.forwardExit,
      exitActive: styles.forwardExitActive,
    },
    backward: {
      enter: styles.backwardEnter,
      enterActive: styles.backwardEnterActive,
      exit: styles.backwardExit,
      exitActive: styles.backwardExitActive,
    },
  };

  return (
    <div className={styles.wrapper}>
      <TransitionGroup
        component={null}
        childFactory={(child) => React.cloneElement(child, {
          classNames: animClasses[activeDirection],
        })}
      >
        <CSSTransition
          key={stepKey}
          timeout={240}
          classNames={animClasses[activeDirection]}
          unmountOnExit
        >
          <div className={styles.stepContainer}>
            {children}
          </div>
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};

AnimatedStepSwitcher.propTypes = {
  children: PropTypes.node.isRequired,
  stepKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  direction: PropTypes.oneOf(['forward', 'backward']),
};

AnimatedStepSwitcher.defaultProps = {
  direction: null,
};

export default AnimatedStepSwitcher;
